import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { fmtTime } from "../preview/meta";

const KIND = { add: "Add", move: "Move", remove: "Remove", create_subscription: "New sub" };
const TONE = { done: "bg-emerald-50 text-emerald-700 border-emerald-200", failed: "bg-red-50 text-red-700 border-red-200",
  running: "bg-sky-50 text-sky-700 border-sky-200" };

function Changes({ r }) {
  const k = Object.entries(r.by_kind || {});
  return k.length ? k.map(([x, n]) => `${KIND[x] || x} ${n}`).join(" · ") : <span className="text-slate-400">nothing to change</span>;
}

/** The last 30 sync runs: what changed, what failed, problems, the e-mail, and the way into Apply History. */
export function SyncRunsTable({ runs }) {
  return (
    <Card className="overflow-hidden" data-testid="tis-runs">
      <div className="border-b border-slate-100 px-5 py-3 text-sm font-semibold text-slate-800">Recent syncs <span className="font-normal text-slate-400">— each day's changes are in Apply History</span></div>
      {!runs.length ? <p className="px-5 py-6 text-sm text-slate-500" data-testid="tis-runs-empty">No syncs yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="bg-slate-50 text-left text-[10px] uppercase tracking-wide text-slate-500">
              <tr><th className="px-5 py-2">When</th><th className="px-3 py-2">Started</th><th className="px-3 py-2">Result</th><th className="px-3 py-2">Changes</th>
                <th className="px-3 py-2">Applied · skipped · failed</th><th className="px-3 py-2">Problems</th><th className="px-3 py-2">E-mail</th><th className="px-5 py-2" /></tr>
            </thead>
            <tbody>
              {runs.map((r) => {
                const c = r.counts || {};
                return (
                  <tr key={r.id} className="border-t border-slate-100 align-top" data-testid={`tis-run-${r.id}`}>
                    <td className="px-5 py-2.5 text-slate-700">{fmtTime(r.at)}<div className="font-mono text-[10px] text-slate-400">{r.run_id || r.id}</div></td>
                    <td className="px-3 py-2.5 text-slate-600">{r.trigger === "schedule" ? "On schedule" : `By ${r.by}`}</td>
                    <td className="px-3 py-2.5"><span className={`rounded border px-1.5 py-px text-[10px] font-semibold ${TONE[r.status] || TONE.done}`}>{r.status}</span>
                      {r.error && <div className="mt-1 max-w-[260px] text-[11px] text-red-600">{r.error}</div>}</td>
                    <td className="px-3 py-2.5 text-slate-600"><Changes r={r} /></td>
                    <td className="px-3 py-2.5 font-mono">{c.applied || 0} · {c.skipped || 0} · <span className={c.failed ? "font-semibold text-red-600" : ""}>{c.failed || 0}</span></td>
                    <td className="px-3 py-2.5">{r.issues_total ?? "—"}{r.issues_new ? <span className="ml-1 rounded bg-amber-100 px-1 text-[10px] font-semibold text-amber-800">{r.issues_new} new</span> : null}</td>
                    <td className="px-3 py-2.5 text-slate-500" title={(r.email?.to || []).join(", ")}>{r.email?.status || "—"}</td>
                    <td className="px-5 py-2.5 text-right">{r.apply_id && <Link to={`/billing-sync/apply-history/${r.apply_id}`} className="font-medium text-emerald-700 hover:underline" data-testid={`tis-run-open-${r.id}`}>Rows →</Link>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
